import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {

  ngOnInit() {
    this.resetPassword();
  }

  resetPassword() {
    let orginalUrl = window.location.href;
    let orginUrl = orginalUrl.replaceAll('reset-password','login');
    window.location.href = `${environment.cognito.domain}/forgotPassword?client_id=${environment.cognito.clientId}&redirect_uri=${orginUrl}&response_type=${environment.cognito.responseType}&scope=${environment.cognito.scope}`
  }

}
